import { render, staticRenderFns } from "./editProduct.vue?vue&type=template&id=5f3d1120&scoped=true"
import script from "./editProduct.vue?vue&type=script&lang=js"
export * from "./editProduct.vue?vue&type=script&lang=js"
import style0 from "./editProduct.vue?vue&type=style&index=0&id=5f3d1120&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3d1120",
  null
  
)

export default component.exports